const storeIdvalue = localStorage.getItem("currentStore");
const state = () => ({
  showMsg: false,
  noTip: false,
  startTime: "",
  endTime: "",
  date11: "",
  date22: "",
  storeId: storeIdvalue ? Number(storeIdvalue) : "",
});

const getters = {
  showMsg: (state) => state.showMsg,
  noTip: (state) => state.noTip,
  startTime: (state) => state.startTime,
  endTime: (state) => state.endTime,
  date11: (state) => state.date11,
  date22: (state) => state.date22,
  storeId: (state) => state.storeId,
};

const mutations = {
  setshowMsg(state, showMsg) {
    state.showMsg = showMsg;
  },
  setnoTip(state, noTip) {
    state.noTip = noTip;
  },
  setStartTime(state, startTime) {
    state.startTime = startTime;
  },
  setEndTime(state, endTime) {
    state.endTime = endTime;
  },
  setDate11(state, date11) {
    state.date11 = date11;
  },
  setDate22(state, date22) {
    state.date22 = date22;
  },
  setStoreId(state, storeId) {
    state.storeId = storeId;
  },
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
